import React from 'react'

const SvgBugOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.915 10.909A1.597 1.597 0 004.43 12H5a1 1 0 100-2h-.28l-.772-2.316a1 1 0 10-1.897.633l.864 2.592zM21.084 10.909A1.596 1.596 0 0119.57 12H19a1 1 0 110-2h.279l.772-2.316a1 1 0 111.898.633l-.865 2.592zM2.915 18.092A1.596 1.596 0 014.43 17H6a1 1 0 110 2H4.72l-.772 2.316a1 1 0 11-1.897-.632l.864-2.592zM2 14.5a1 1 0 001 1h2a1 1 0 100-2H3a1 1 0 00-1 1zM18 14.5a1 1 0 001 1h2a1 1 0 100-2h-2a1 1 0 00-1 1zM15.553 6.28a1 1 0 01-.448-1.341l1.193-2.386a1 1 0 111.79.894l-1.194 2.386a1 1 0 01-1.341.448zM8.64 6.28a1 1 0 01-1.342-.447L6.105 3.447a1 1 0 111.79-.894l1.192 2.386a1 1 0 01-.447 1.342zM21.084 18.092A1.596 1.596 0 0019.57 17H18a1 1 0 100 2h1.279l.772 2.316a1 1 0 101.898-.632l-.865-2.592z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.014 22.006c-2.1-.286-3.682-1.482-4.676-3.178-.954-1.63-1.347-3.672-1.347-5.81 0-.728.055-2.27.236-3.336a2 2 0 011.972-1.667H16.8a2 2 0 011.972 1.667c.18 1.066.236 2.608.236 3.335 0 2.139-.393 4.18-1.347 5.81-.994 1.697-2.576 2.893-4.676 3.179a8.479 8.479 0 01-1.97 0zm1.994-1.994v-5.018a.997.997 0 00-1.994 0v5.01c-.588-.116-1.256-.43-1.73-.787-1.529-1.152-2.293-3.388-2.293-6.2 0-.69.055-2.1.208-3.002H16.8c.153.902.208 2.312.208 3.002 0 2.812-.764 5.048-2.293 6.2a5.057 5.057 0 01-1.707.795z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.802 5.861c1.122-1.556 2.784-2.884 5.157-2.884 2.372 0 4.072 1.326 5.22 2.885 1.1 1.495 1.517 3.3 1.813 4.888l-1.966.367c-.294-1.574-.652-2.974-1.458-4.07-.918-1.247-2.087-2.07-3.609-2.07-1.511 0-2.64.812-3.534 2.054-.8 1.11-1.16 2.515-1.456 4.087l-1.965-.37c.299-1.588.717-3.386 1.798-4.887z'
    />
  </svg>
)

export default SvgBugOutline
